import { FunnelCreationStatusEnum } from 'modules/funnels/enums/funnel-creation-status-enum'
import { FunnelInterface } from 'modules/funnels/types/funnel-interface'

export const isFunnelCreated = (funnel: FunnelInterface) =>
  funnel.creationStatus === FunnelCreationStatusEnum.Completed
